<div class="spinner-container" *ngIf="loading">
  <mat-spinner class="content-box"></mat-spinner>
</div>
<p *ngIf="!loading && onEmptyDevices">{{'deviceTexts.noDevices' | translate}}</p>
<div id="wrapper" *ngIf="!loading && !onEmptyDevices">
  <div *ngIf="!isSubcomponent" class="filter-container" autofocus>
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="{{'common.filter' | translate}}">
    </mat-form-field>
  </div>

  <div *ngIf="!wait" class="mat-elevation-z8">
    <mat-table *ngIf="dataSource" [dataSource]="dataSource" matSort [matSortActive]="registrationDate">

      <!-- Статус -->
      <ng-container matColumnDef="status">
        <mat-header-cell class="d-none d-sm-flex" *matHeaderCellDef mat-sort-header> {{'deviceTexts.status' |
          translate}} </mat-header-cell>
        <mat-cell *matCellDef="let row" class="tac d-none d-sm-flex"
          matTooltip="{{statusIcon(row.status).tooltip | translate}}">
          <cqes-icon [icon]="statusIcon(row.status)?.icon" [iconClass]="statusIcon(row.status)?.colorClass"></cqes-icon>
        </mat-cell>
      </ng-container>

      <!-- Common Name -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'deviceTexts.name'| translate}} </mat-header-cell>
        <mat-cell *matCellDef="let row" class="flex-column align-items-start justify-content-center">
          <div>
            {{row.name}}
          </div>
          <div class="device-app-id-container">
            {{'deviceTexts.id'| translate}}: {{row.appId}}
          </div>
        </mat-cell>
      </ng-container>

      <!-- Дата на регистрация -->
      <ng-container matColumnDef="registrationDate">
        <mat-header-cell id="regDate" class="d-none d-md-flex" *matHeaderCellDef mat-sort-header>
          {{'deviceTexts.registrationDate'| translate}} </mat-header-cell>
        <mat-cell *matCellDef="let row" class="d-none d-md-flex">
          {{row.registrationDate | date: dateFormat}}<br>{{row.registrationDate | date: timeFormat}}
        </mat-cell>
      </ng-container>

      <!-- Последен ъпдейт -->
      <ng-container matColumnDef="lastUpdateDate">
        <mat-header-cell id="lastUpdate" class="d-none d-lg-flex" *matHeaderCellDef mat-sort-header>
          {{'deviceTexts.lastUpdateDate'| translate}}</mat-header-cell>
        <mat-cell class="d-none d-lg-flex" *matCellDef="let row">
          {{row.lastUpdateDate | date: dateFormat}}<br>{{row.lastUpdateDate | date: timeFormat}}
        </mat-cell>
      </ng-container>

      <!-- Брой удостоверения -->
      <ng-container matColumnDef="certCnt">
        <mat-header-cell id="certCnt" class="d-none d-lg-flex" *matHeaderCellDef mat-sort-header>
          {{'deviceTexts.certIds'| translate}} </mat-header-cell>
        <mat-cell class="d-none d-lg-flex" *matCellDef="let row"> {{row.certificateReqIds.length}} </mat-cell>
      </ng-container>

      <!-- Действия -->
      <ng-container matColumnDef="actions" class="tar">
        <mat-header-cell *matHeaderCellDef translate> {{'deviceTexts.actions'| translate}} </mat-header-cell>
        <mat-cell *matCellDef="let row" translate>
          <span [matMenuTriggerFor]="actionsMenu">
            <button mat-icon-button color="primary">
              <cqes-icon icon="menu"></cqes-icon>
            </button>
          </span>
          <mat-menu #actionsMenu [overlapTrigger]="false" class="nav-responsive-overlay">
            <button mat-menu-item *ngIf="!selectedCert" color="primary"
              matTooltip="{{'deviceTexts.tooltips.certs' | translate}}" (click)="showCertificates(row)">
              <cqes-icon icon="screen_lock_landscape"></cqes-icon>
              {{'deviceTexts.tooltips.certs' | translate}}
            </button>
            <div></div>
            <button mat-menu-item *ngIf="!selectedCert" color="primary"
              matTooltip="{{'deviceTexts.tooltips.deleteAll' | translate}}" (click)="deleteDevice(row)">
              <cqes-icon icon="delete"></cqes-icon>
              {{'deviceTexts.tooltips.deleteAll' | translate}}
            </button>
            <button mat-menu-item *ngIf="selectedCert" color="primary"
              matTooltip="{{'deviceTexts.tooltips.removeFromCert' | translate}}"
              (click)="removeDeviceFromCertificate(row)">
              <cqes-icon icon="remove_circle"></cqes-icon>
              {{'deviceTexts.tooltips.removeFromCert' | translate}}
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
</div>